const suitColors = {
    clubs: '#81b539',
    diams: '#ff6f00',
    hearts: '#ff0000',
    spades: '#3c66ff',
    nt: '#000000'
};
createAlias(suitColors);

const doubleColors = {
    fontColor: '#FFFFFF',
    pass: '#006400',
    double: '#FF0000',
    redouble: '#00008B'
};
//Add aliases (cannot put it in curly braces)
doubleColors[0] = doubleColors.pass;
doubleColors[1] = doubleColors.double;
doubleColors[2] = doubleColors.redouble;

const suitSymbols = {
    clubs: '&clubs;',
    diams: '&diams;',
    hearts: '&hearts;',
    spades: '&spades;',
    nt: 'NT'
};
createAlias(suitSymbols);


const suitHtml = {
    clubs: '<span style="color: ' + suitColors.clubs + '; font-size: 140%;" class="_htmlSuiteClass">' + suitSymbols.clubs + '</span>',
    diams: '<span style="color: ' + suitColors.diams + '; font-size: 140%;" class="_htmlSuiteClass">' + suitSymbols.diams + '</span>',
    hearts: '<span style="color: ' + suitColors.hearts + '; font-size: 130%;" class="_htmlSuiteClass">' + suitSymbols.hearts + '</span>',
    spades: '<span style="color: ' + suitColors.spades + '; font-size: 140%;" class="_htmlSuiteClass">' + suitSymbols.spades + '</span>',
    nt: '<span style="color: ' + suitColors.nt + '">NT</span>'
};
createAlias(suitHtml);

function createAlias(objectWithSuits) {
    //Add aliases (cannot put it in curly braces)
    objectWithSuits[0] = objectWithSuits.clubs;
    objectWithSuits[1] = objectWithSuits.diams;
    objectWithSuits[2] = objectWithSuits.hearts;
    objectWithSuits[3] = objectWithSuits.spades;
    objectWithSuits[4] = objectWithSuits.nt;
}

function convertCardToInt(rank, suit) {
    if (rank === null || suit === null) {
        return 0;
    }
    const convertedRank = rank.replace("10", "T");
    const rankArray = ["A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"];
    //Transit suit is reversed
    suit = 3 - suit;
    return suit * 13 + rankArray.indexOf(convertedRank);
}

function addColorToSuite(contract) {
    if (contract == null || contract.length === 0) {
        return "";
    }
    const baseLength = contract.length;

    const replacePairArray = [
        [/♣/, suitHtml[0]],
        [/♦/, suitHtml[1]],
        [/♥/, suitHtml[2]],
        [/♠/, suitHtml[3]],

        [/F/, suitHtml[0]],
        [/Q/, suitHtml[1]],
        [/C/, suitHtml[2]],

        //Not PASS
        [/P([^A])/, suitHtml[3] + '$1']
    ]

    let ret;
    for (const replacePair of replacePairArray) {
        ret = contract.replace(replacePair[0], replacePair[1]);
        if (ret.length !== baseLength) {
            break;
        }
    }

    return ret;
}


export {suitColors, suitSymbols, suitHtml, doubleColors, convertCardToInt, addColorToSuite};
